import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const excludedUrls = [
    '/auth/login',
    '/auth/register',
    '/auth/forgot-password',
    '/login',
    '/register',
    '/forgot-password',
    '/public/',
    '/university/active',
    '/letter/year',
    '/degree-taught/university',
    '/links/send-class-link',
    'identitytoolkit.googleapis.com',
  ];

  const isExcluded = excludedUrls.some(url => req.url.includes(url));
  if (isExcluded) {
    return next(req);
  }

  const token = authService.getCurrentToken();

  if (router.url.startsWith('/public')) {
    return next(req);
  }

  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      }
    });

    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && error.error.message === 'Token expired') {
          authService.logout().subscribe({
            next: () => {
              router.navigate(['/auth/login'], { queryParams: { sessionExpired: true } });
            }
          });
        }
        return throwError(() => error);
      })
    );
  } else {
    authService.logout().subscribe({
      next: () => {
        router.navigate(['/auth/login'], { queryParams: { sessionExpired: true } });
      }
    });
  }

  return next(req);
}; 